import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { FaArrowLeft, FaShieldAlt, FaCreditCard } from 'react-icons/fa';
import MP_RGB_HANDSHAKE_color_horizontal from '../assets/MP_RGB_HANDSHAKE_color_horizontal.png';
import './Checkout.css';

const Checkout = () => {
  const { cart } = useCart();
  const navigate = useNavigate();

  // Estados del formulario
  const [metodoPago, setMetodoPago] = useState('mercadopago'); // Por defecto seleccionado MP
  const [mostrarDistribuidor, setMostrarDistribuidor] = useState(false);
  const [codigoIngresado, setCodigoIngresado] = useState('');
  const [distribuidorAprobado, setDistribuidorAprobado] = useState(false);
  const [mensajeDistribuidor, setMensajeDistribuidor] = useState({ tipo: '', texto: '' });
  const [cliente, setCliente] = useState({
    nombre: '',
    whatsapp: '',
    notas: '',
    direccion: '', // NUEVO
    dni: '',       // NUEVO
    cuit_cuil: '', // NUEVO
  });
  const [cargando, setCargando] = useState(false);

  //CODIGOS DISTRIBUIDOR
  const codigosMayoristas = ['DK3G20', 'YU92TY', 'RP9L01'];

  const calcularKilosPedido = () => {
    return cart.reduce((acc, item) => {
      let pesoItem = 0;
      
      // Mapeamos los formatos exactos a sus kilos correspondientes
      switch (item.formato) {
        case 'Porción':
          pesoItem = 0.400;
          break;
        case 'Media horma':
          pesoItem = 0.500;
          break;
        case 'Barra':
          pesoItem = 3.000;
          break;
        case 'Horma 1kg':
        case 'Botella':
          pesoItem = 1.000;
          break;
        case 'Horma 5kg':
          pesoItem = 5.000;
          break;
        default:
          pesoItem = 0; // Por seguridad, si hay un formato no mapeado
      }
      
      return acc + (pesoItem * item.cantidad);
    }, 0);
  };

  const validarCodigo = async () => {
    const codigo = codigoIngresado.trim().toUpperCase();
    if (!codigo) return;

    setMensajeDistribuidor({ tipo: '', texto: 'Validando...' });
    const kilosDelPedido = calcularKilosPedido();

    try {
      const respuesta = await fetch('https://api.pascolo.com.ar/api/web/validar-distribuidor', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ codigo: codigo, kilosPedido: kilosDelPedido })
      });

      const data = await respuesta.json();

      if (!respuesta.ok) {
        setMensajeDistribuidor({ tipo: 'error', texto: data.error });
        setDistribuidorAprobado(false);
        return;
      }

      // Si el backend da el OK:
      setMensajeDistribuidor({ tipo: 'exito', texto: '¡Código mayorista aplicado! Precio actualizado.' });
      setDistribuidorAprobado(true);
      // Opcional: Podés guardar data.id_distribuidor en un estado para mandarlo al final
      
    } catch (error) {
      setMensajeDistribuidor({ tipo: 'error', texto: 'Error de conexión. Intentá nuevamente.' });
      setDistribuidorAprobado(false);
    }
  };

  // Si alguien entra a /checkout con el carrito vacío, lo pateamos al catálogo
  if (cart.length === 0) {
    return (
      <div className="checkout-vacio">
        <h2>Tu carrito está vacío</h2>
        <p>Necesitás agregar productos antes de poder pagar.</p>
        <Link to="/productos" className="btn-volver-catalogo">Ir al catálogo</Link>
      </div>
    );
  }

  const totalPedido = cart.reduce((total, item) => total + (item.precio_unitario * item.cantidad), 0);

  const formatearPrecio = (precio) => {
    return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' }).format(precio);
  };

  const handleInputChange = (e) => {
    setCliente({
      ...cliente,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setCargando(true);

    if (distribuidorAprobado) {
      const kilosDelPedido = calcularKilosPedido();
      const fecha = new Date();
      const storageKey = `uso_kg_${codigoIngresado}_${fecha.getMonth()}_${fecha.getFullYear()}`;
      const kilosAnteriores = parseFloat(localStorage.getItem(storageKey)) || 0;
      
      // Guardamos los kilos acumulados
      localStorage.setItem(storageKey, kilosAnteriores + kilosDelPedido);
    }

    // CORRECCIÓN 1: Desarmamos el objeto cliente e items para mandarlo 
    // con los nombres exactos que desestructura tu backend en AWS
    const pedido = {
      cliente_nombre: cliente.nombre || cliente, // Adaptalo según si 'cliente' es un objeto o un string
      cliente_whatsapp: cliente.whatsapp || '',
      cliente_direccion: cliente.direccion || '',
      dni: cliente.dni || '',
      cart: cart, // El backend espera 'cart', no 'items'
      codigoDistribuidor: codigoIngresado || null
    };

    try {
      const respuesta = await fetch('https://api.pascolo.com.ar/api/web/checkout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(pedido)
      });

      // Si usamos el parche del 200 en el backend con 'exito: false', leemos la respuesta primero
      const data = await respuesta.json();

      if (data.exito === false) {
        throw new Error(data.mensaje || "Error interno en la lógica del servidor");
      }

      // CORRECCIÓN 2: El backend unificado responde 'linkPago'
      const urlMercadoPago = data.linkPago || data.init_point;

      if (urlMercadoPago && urlMercadoPago !== 'N/A') {
        window.location.href = urlMercadoPago; // Redirección directa a Mercado Pago Sandbox
      } else {
        throw new Error("No se generó el link de pago");
      }

    } catch (error) {
      console.error(error);
      alert(error.message || "Hubo un problema al procesar tu pedido. Por favor, intentá de nuevo.");
      setCargando(false);
    }
  };

  return (
    <div className="checkout-container">
      <div className="checkout-header">
        <button className="btn-back" onClick={() => navigate(-1)}>
          <FaArrowLeft /> Volver
        </button>
        <h1>Finalizar Compra</h1>
      </div>

      <div className="checkout-grid">
        {/* Columna Izquierda: Formulario */}
        <div className="checkout-form-section">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Nombre y Apellido (o Razón Social) *</label>
              <input 
                type="text" 
                name="nombre" 
                value={cliente.nombre} 
                onChange={handleInputChange} 
                required 
                placeholder="Ej: Juan Pérez"
              />
            </div>

            <div className="form-group">
              <label>Número de WhatsApp *</label>
              <input 
                type="tel" 
                name="whatsapp" 
                value={cliente.whatsapp} 
                onChange={handleInputChange} 
                required 
                placeholder="Ej: 2991234567"
              />
              <small>Te vamos a contactar por acá para coordinar el retiro.</small>
            </div>

            <div className="form-group">
              <label>DNI *</label>
              <input 
                type="text" 
                name="dni" 
                value={cliente.dni} 
                onChange={handleInputChange} 
                required 
                placeholder="Sin puntos, ej: 35123456"
              />
              <small>Te servirá para hacer el seguimiento de tu pedido.</small>
            </div>

            <div className="form-group">
              <label>CUIT / CUIL *</label>
              <input 
                type="text" 
                name="cuit_cuil" 
                value={cliente.cuit_cuil} 
                onChange={handleInputChange} 
                required
              />
            </div>

            <div className="form-group">
              <label>Dirección *</label>
              <input 
                type="text" 
                name="direccion" 
                value={cliente.direccion} 
                onChange={handleInputChange} 
                required 
                placeholder="Ej: San Martín 123, Cipolletti"
              />
            </div>

            {/* --- SECCIÓN DE MÉTODOS DE PAGO --- */}
            <div className="payment-section">
              <label style={{ fontWeight: 'bold', marginBottom: '10px', display: 'block', color: '#444' }}>
                Método de Pago
              </label>
              <div className="payment-methods">
                
                {/* Tarjeta Única: Mercado Pago */}
                <div 
                  className={`payment-card ${metodoPago === 'mercadopago' ? 'selected mp' : ''}`}
                  onClick={() => setMetodoPago('mercadopago')}
                >
                  <div className="payment-card-header">
                    <input 
                      type="radio" 
                      checked={metodoPago === 'mercadopago'} 
                      readOnly 
                    />
                    <img 
                      src={MP_RGB_HANDSHAKE_color_horizontal}
                      alt="Mercado Pago" 
                      style={{ height: '75px', marginLeft: '8px' }}
                    />
                  </div>
                </div>

                {/* Acá a futuro podés agregar más <div className="payment-card">... */}

              </div>
            </div>

            <div className="info-retiro">
              <p><strong>Aviso Importante:</strong> No realizamos envíos a domicilio. El pedido debe ser retirado por nuestra fábrica.</p>
            </div>

            {/* BOTÓN DE CONFIRMACIÓN */}
            <button 
              type="submit" 
              className="btn-pagar" 
              disabled={cargando}
            >
              {cargando ? 'Procesando...' : 'Realizar pedido'}
            </button>
            <p className="pago-seguro"><FaShieldAlt /> Tu pago es procesado de forma 100% segura.</p>
          </form>
        </div>

        {/* Columna Derecha: Resumen del Pedido */}
        <div className="checkout-summary-section">
          <h3>Resumen del Pedido</h3>
          <div className="summary-items">
            {cart.map((item, index) => (
              <div key={index} className="summary-item" style={{ marginBottom: '15px', paddingBottom: '15px', borderBottom: '1px dashed #eee' }}>
                <div className="summary-item-info" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  
                  {/* --- NUEVA IMAGEN --- */}
                  <img 
                    src={item.imagen_url} 
                    alt={item.nombre} 
                    style={{ 
                      width: '50px', 
                      height: '50px', 
                      objectFit: 'cover', 
                      borderRadius: '6px',
                      border: '1px solid #ddd'
                    }}
                  />
                  
                  <span className="summary-cant">{item.cantidad}x</span>
                  <div>
                    <span className="summary-name">{item.nombre}</span>
                    <span className="summary-var">{item.formato} - {item.maduracion === 0 ? 'Fresco' : `${item.maduracion} días`}</span>
                  </div>
                </div>
                <div className="summary-price" style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
                  {formatearPrecio(item.precio_unitario * item.cantidad)}
                </div>
              </div>
            ))}
          </div>
          
          {/* --- TOTAL DINÁMICO --- */}
          <div className="summary-total" style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px', paddingTop: '15px', borderTop: '2px solid #2d5a27', fontSize: '1.2rem', fontWeight: 'bold' }}>
            <span>Total a pagar</span>
            <span>
              {distribuidorAprobado ? (
                <>
                  {/* Precio tachado original */}
                  <span style={{ textDecoration: 'line-through', color: '#999', fontSize: '0.8em', marginRight: '10px', fontWeight: 'normal' }}>
                    {formatearPrecio(totalPedido)}
                  </span>
                  {/* Precio con descuento (total * 0.6) */}
                  <span style={{ color: '#2d5a27' }}>
                    {formatearPrecio(totalPedido * 0.6)}
                  </span>
                </>
              ) : (
                formatearPrecio(totalPedido)
              )}
            </span>
          </div>

          {/* --- SECCIÓN DISTRIBUIDOR --- */}
          <div className="distribuidor-section" style={{ marginTop: '20px' }}>
            <span 
              onClick={() => setMostrarDistribuidor(!mostrarDistribuidor)}
              style={{ color: '#009ee3', fontWeight: 'bold', cursor: 'pointer', fontSize: '14px', textDecoration: 'underline' }}
            >
              ¿Sos distribuidor?
            </span>

            {mostrarDistribuidor && (
              <div style={{ marginTop: '12px', display: 'flex', flexDirection: 'column', gap: '8px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px dashed #ccc' }}>
                <label style={{ fontSize: '13px', fontWeight: 'bold', color: '#555' }}>Ingresá tu código mayorista:</label>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <input 
                    type="text" 
                    maxLength={6}
                    placeholder="EJ: MAYOR1"
                    value={codigoIngresado}
                    onChange={(e) => setCodigoIngresado(e.target.value.toUpperCase())}
                    style={{ flex: 1, padding: '10px', borderRadius: '6px', border: '1px solid #ccc', textTransform: 'uppercase', letterSpacing: '2px', fontWeight: 'bold' }}
                  />
                  <button 
                    type="button" 
                    onClick={validarCodigo}
                    style={{ padding: '10px 20px', backgroundColor: '#333', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}
                  >
                    Aplicar
                  </button>
                </div>
                
                {mensajeDistribuidor.texto && (
                  <span style={{ fontSize: '13px', color: mensajeDistribuidor.tipo === 'error' ? '#d9534f' : '#2d5a27', fontWeight: 'bold', marginTop: '5px' }}>
                    {mensajeDistribuidor.texto}
                  </span>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checkout;